import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const roadmapOptions = {
  baseUrl: `${BACK_END_URL}/access`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class RoadmapClient extends CandyClient {
  constructor() {
    super(roadmapOptions);
  }

  async getRoadmap(courseId) {
    return this.get(`/curso/${courseId}/roadmap`, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
  }
}
